import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { QuickLoanService } from "../../_QuickLoan/services/quickLoan.service";

@Component({
  selector: "app-filechecking-dialog",
  templateUrl: "./filechecking-dialog.component.html",
  styleUrls: ["./filechecking-dialog.component.scss"],
  standalone: false,
})
export class FileCheckingDialogComponent implements OnInit {
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  currentUser: any;
  LoanId: any;
  questionData: any[] = [];
  originalQuestionData: any[] = [];
  showSpinner: boolean = false;
  loading: boolean = false;
  IsSave: boolean = false;
  IsUpdate: boolean = false;
  IsEdit: boolean = false;
  IsDisabled: boolean = false;

  actionOptions: string[] = [
    "Completed",
    "Pending",
    "Before Disbursement",
    "After Disbursement",
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FileCheckingDialogComponent>,
    private _QuickLoanService: QuickLoanService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.LoanId = this.data.LoanId;
    this.getFileCheckingData();
  }

  getFileCheckingData() {
    this.showSpinner = true;
    this._QuickLoanService
      .QuickLoan_GetFileChecking({ LoanId: this.LoanId })
      .subscribe((res: any) => {
        this.showSpinner = false;
        if (res.length > 0) {
          this.questionData = res;
          this.IsEdit = res[0].IsExists == 1 ? true : false;
          this.IsSave = res[0].IsExists == 1 ? false : true;
          this.IsDisabled = res[0].IsExists == 1 ? true : false;
          this.questionData.forEach((obj: any) => {
            obj.FileCheckingDropdown = obj.FileCheckingOptions
              ? obj.FileCheckingOptions.split(",")
              : [];
            obj.SelectOption = obj.SelectOption;
            obj.Remark = obj.Remark;
            obj.Action_Status = obj.Action_Status || "";
            obj.CreatedBy = obj.CreatedBy || "";
            obj.CreatedOn = obj.CreatedOn || "";
          });
          this.originalQuestionData = JSON.parse(
            JSON.stringify(this.questionData)
          );
        }
      });
  }

  onSaveCustomerFileChecking() {
    this.loading = true;
    const payloadToSave = this.questionData.filter((obj: any) => {
      if (!obj.Id) {
        return true;
      }
      const original = this.originalQuestionData.find(
        (x) => x.Id === obj.Id
      );
      if (!original) {
        return true;
      }
      return (
        obj.SelectOption !== original.SelectOption ||
        obj.Remark !== original.Remark ||
        obj.Action_Status !== original.Action_Status
      );
    });

    this._QuickLoanService
      .Quick_Save_FileChecking({
        JSON: JSON.stringify(payloadToSave),
        LoanId: this.LoanId,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((response: any) => {
        if (response[0].CODE >= 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
          this.getFileCheckingData();
          this.dialogRef.close(true);
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
        }
        this.loading = false;
      });
  }

  onEditFileChecking() {
    this.IsEdit = false;
    this.IsUpdate = true;
    this.IsSave = false;
    this.IsDisabled = false;
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
